import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-24ffff1c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "income-card"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "count"
};
const _hoisted_4 = {
  class: "title"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'card',
  props: {
    count: {},
    title: {},
    unit: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.count), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title) + " (" + _toDisplayString(_ctx.unit) + ")", 1)])]),
        _: 1
      })]);
    };
  }
});